import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { MdaSidemenuComponent } from '../../shared/widgets/mda-sidemenu/mda-sidemenu.component';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../core/store';
import { Subscription } from 'rxjs';
import { getSettingsStore } from '../../core/store/selectors/settings.selectors';
import { AdminHeaderComponent } from '../../shared/widgets/admin-header/admin-header.component';

@Component({
  selector: 'app-mda-layout',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    AdminHeaderComponent,
    NzLayoutModule,
    MdaSidemenuComponent,
  ],
  templateUrl: './mda.component.html',
  styleUrl: './mda.component.css',
})
export class MdaLayoutComponent implements OnInit, OnDestroy {
  store = inject(Store<AppState>);

  settingsStoreSub: Subscription;

  isCollapsed = signal(false);

  ngOnInit(): void {
    this.settingsStoreSub = this.store
      .pipe(select(getSettingsStore))
      .subscribe((settingsStore) => {
        this.isCollapsed.set(settingsStore.sideMenuCollapsedState);
      });
  }

  ngOnDestroy(): void {
    if (this.settingsStoreSub) this.settingsStoreSub.unsubscribe();
  }
}
